import useAuth from './useAuth';
import { getAccessLevelDisplay } from '@/utils/getAccessLevelDisplay';

export interface TUserProfile {
  name: string;
  email: string | undefined;
  photoURL: string | undefined;
  preferredName: string | undefined;
  accountType: string | undefined;
  accessLevel: string;
}

export const useProfile = (): TUserProfile => {
  const authContext = useAuth();
  const customer = authContext?.customer;
  const business = authContext?.business;
  const accountType = authContext?.accountType;

  const email =
    authContext?.accountEmailConfirmed && authContext.accountEmail
      ? authContext.accountEmail
      : customer?.email;

  return {
    name: customer?.name ?? '',
    email,
    photoURL: authContext?.photoURL,
    preferredName: customer?.preferredName,
    accountType,
    accessLevel: getAccessLevelDisplay(accountType, business?.accessLevel)
  };
};
